/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const ko_profileedit_fields_bio1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`자기소개`)
};

const en_profileedit_fields_bio1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bio`)
};

const ja_profileedit_fields_bio1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`自己紹介`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "ko" | "en" | "ja" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
const profileedit_fields_bio1 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.profileedit_fields_bio1(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("profileedit_fields_bio1", locale)
	if (locale === "ko") return ko_profileedit_fields_bio1(inputs)
	if (locale === "en") return en_profileedit_fields_bio1(inputs)
	return ja_profileedit_fields_bio1(inputs)
};
export { profileedit_fields_bio1 as "profileEdit_fields_bio" }